module.exports = __webpack_public_path__ + "Writing.a3d378d1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/graphics/Writing.png
// module id = EdbA
// module chunks = 0